export const subscriptionsColumn = [
  { Header: 'Course Name', accessor: 'program_name' },
  { Header: 'Subscription Date', accessor: 'program_seo_url' },
  { Header: 'Validity Tenure', accessor: 'offer' },
  { Header: 'Offer Validity', accessor: 'offer_validity' },
	{ Header: 'Action', accessor: '' },
];
